#import "../fragments/next-steps-slack-message-fragment.graphql"

mutation FormNextStepsSlackMessageDelete($input: FormNextStepsSlackMessageDeleteInput!) {
    formNextStepsSlackMessageDelete(input: $input) {
        slackMessage {
            ...NextStepsSlackMessageFragment
        }
    }
}
